angular.
module("dx.webapp.import").
constant("DX_QTI_QUESTION_TYPE", Object.freeze({
	UNIDENTIFIED: 0,
	TRUE_FALSE: 1,
	MULTIPLE_RESPONSE: 2,
	MULTIPLE_CHOICE: 3,
	ESSAY: 4,
	FILL_IN_BLANK: 5,
	FILL_IN_MULTIPLE_BLANKS: 6,
	MULTIPLE_DROWDOWNS: 7,
	MATCHING: 8,
	NUMERICAL: 9,
	CALCULATED: 10,
	FILE_UPLOAD: 11,
	TEXT_ONLY: 12,
	EITHER_OR: 13,
	HOT_SPOT: 14,
	OPINION_SCALE: 15,
	ORDERING: 16,
	QUIZ_BOWL: 17,
	SHORT_RESPONSE: 18,
	AUDIO_RESPONSE: 19,
	SURVEY_MATRIX: 20,
	PATTERN_MATCH: 21,
}));
